<div class="betslip-taxation-info" *ngIf="isVisible">
    <ng-container *ngIf="!!vm.taxationAmount && vm.possibleWinningsGross && vm.possibleWinningsNet">
        <div class="betslip-taxation-info__row">
            <div class="betslip-taxation-info_text" [ngClass]="isBoosted ? 'highlight' : ''">{{ grossNonBoostedWinningsMessage }}</div>
            <div class="betslip-taxation-info_value">
                <div class="money_amount highlight">{{ vm.possibleWinningsGross | bsCurrency: true }}</div>
            </div>
        </div>
        <div class="betslip-taxation-info__row">
            <div class="betslip-taxation-info_text">{{ taxationTitle }}</div>
            <div class="betslip-taxation-info_value">
                <div class="money_amount"><span *ngIf="isTurnoverTax">-</span>{{ vm.taxationAmount | bsCurrency: true }}</div>
            </div>
        </div>
        <div class="betslip-taxation-info__row betslip-taxation-info_taxation-liability" *ngIf="vm.taxationLiability">
            <div class="betslip-taxation-info_text">{{ vm.taxationLiabilityTitle }}</div>
            <div class="betslip-taxation-info_value">
                <div class="money_amount">{{ vm.taxationLiability | bsCurrency: true }}</div>
            </div>
        </div>
        <div class="betslip-taxation-info__row" *ngIf="isBoosted">
            <div class="betslip-taxation-info_text highlight">{{ messages.boostedPossibleWinnings }}</div>
            <div class="betslip-taxation-info_value">
                <div class="money_amount highlight">{{ vm.winningsBoost | bsCurrency: true }}</div>
            </div>
        </div>
        <div class="betslip-taxation-info__row">
            <div class="betslip-taxation-info_text">{{ messages.possibleWinningsNet }}</div>
            <div class="betslip-taxation-info_value">
                <div class="money_amount highlight">{{ vm.possibleWinningsNet | bsCurrency: true }}</div>
            </div>
        </div>
    </ng-container>

    @if (messages.taxationHelpUrl) {
        <bs-digital-taxation-info-help-text [helpText]="messages.taxationHelpText" [helpUrl]="messages.taxationHelpUrl" />
    }

    <div class="betslip-taxation-info_ok-text" (click)="close()">{{ messages.closeButton }}</div>
</div>
